import type { CustomError, PaginationResponse, UpdateResponse } from 'core/base';
import { BaseRepository } from 'core/base';
import type { DocumentId, DocumentRevision } from 'core/types';
import type { AxiosRequestConfig } from 'axios';
import type { CommentModel } from './Comment.model';

export class CommentsRepository extends BaseRepository {
  constructor() {
    super('/comments');
  }

  async getAll() {
    const { data } = await this.httpClient.get<PaginationResponse<CommentModel>>('/');

    return data;
  }

  async getByType(typeName: string, id: DocumentId) {
    const { data } = await this.httpClient.get<PaginationResponse<CommentModel>>(
      `/${typeName}/${id}`,
    );

    return data;
  }

  async get(id: DocumentId) {
    const { data } = await this.httpClient.get<CommentModel>(`/${id}`);

    return data;
  }

  async update(model: CommentModel): Promise<CommentModel> {
    const { _id, _rev } = model;
    const config: AxiosRequestConfig = {
      headers: {
        'If-Match': `"${_rev}"`,
      },
    };

    const { headers } = await this.httpClient.put<null, UpdateResponse<null>>(
      `/${_id}`,
      model,
      config,
    );

    return {
      ...model,
      _rev: JSON.parse(headers.etag) as DocumentRevision,
    };
  }

  async create(
    model: CommentModel,
    config?: AxiosRequestConfig,
  ): Promise<{ model: CommentModel; error?: CustomError; ok: boolean }> {
    await this.httpClient.post<UpdateResponse<null>>('/', model, config);

    return {
      model,
      ok: true,
    };
  }
}
